import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface StepHeaderProps {
  title: string;
}

export const StepHeader: React.FC<StepHeaderProps> = ({ title }) => {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>{title}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 30,
  },
});

